<template>
  <div class="translate-wrapper">
    <ValidationObserver
      ref="validationObserver"
      v-slot="{ handleSubmit }"
    >
      <form
        class="contact-info"
        novalidate="novalidate"
        @submit.prevent="handleSubmit(submit)"
        @input="handleFormChange"
      >
        <MaterialInput
          v-model="formData.translateLabel"
          v-bind="formFields.translateLabel"
        />
        <div class="btn-wrapper">
          <div class="btn-wrapper-b">
            <Button
              type="submit"
              :title="'Apply Changes'"
              :classType="'primary'"
            />
            <Button
              :title="'Revert'"
              :classType="'warning'"
              :eventFunction="revertLanguage"
            />
          </div>
          <div
            v-if="isEditedForm.length
              && isEditedForm.find(item => item.id === lang.id && !!item.value)"
            class="changes-wrapper"
          >
            <inline-svg
              :src="iconChanges"
              class="svg-icon"
            >
            </inline-svg>
            <span class="changes-text">
              Unsaved changes
            </span>
          </div>
        </div>
      </form>
    </ValidationObserver>
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex';
import BaseForm from '../BaseForm.vue';
import MaterialInput from '../../inputs/MaterialInput.vue';
import Button from '../../common/Button.vue';
import iconChanges from '../../../assets/icons/icon-localization-changes.svg';

import {
  ADD_LANGUAGE_GENERAL_REQUEST,
  GET_LANGUAGE_GENERAL_REQUEST,
  INIT_FORM_CHANGES,
  SET_FORM_CHANGES,
} from '../../../store/actions/localization/localizationActions';

export default {
  name: 'CmsGeneralForm',
  components: {
    MaterialInput,
    Button,
  },
  extends: BaseForm,
  props: {
    formPrefix: {
      type: String,
      default: 'cmsGeneralForm',
    },
    lang: {
      type: Object,
      default: () => {},
    },
    cmsPage: {
      type: Object,
      default: () => {},
    },
    selected: {
      type: Boolean,
      default: false,
    },
    languages: {
      type: Array,
      default: () => [],
    },
    changedLanguage: {
      type: Function,
      default: () => {},
    },
  },
  data() {
    return {
      iconChanges,
      submitEvent: ADD_LANGUAGE_GENERAL_REQUEST,
      successMessages: `The ${this.lang.name} Localization has been successfully updated`,
      isPosterSmallChanged: false,
      formData: {
        translateLabel: '',
      },
      formFields: {
        translateLabel: {
          type: 'text',
          name: 'translateLabel',
          formPrefix: this.formPrefix,
          rules: {
            required: false,
            max: 25,
          },
        },
      },
      errorMapping: {
        label: [
          `${this.formPrefix}.label`,
        ],
      },
    };
  },
  computed: {
    ...mapState({
      isEditedForm: (state) => state.localization.isEditedForm,
      cmsGeneralLanguage: (state) => state.localization.cmsGeneralLanguage,
    }),
    ...mapGetters([
      'getCurrentAccountId',
    ]),
  },
  created() {
    const value = this.languages.map(((item) => ({
      id: item.id,
      value: false,
    })));
    this.$store.dispatch(INIT_FORM_CHANGES, value);

    const params = {
      accountId: this.getCurrentAccountId,
      cmsPageId: this.cmsPage.id,
      langId: this.lang.id,
    };
    this.$store.dispatch(GET_LANGUAGE_GENERAL_REQUEST, params).then(() => {
      this.initFormData();
    });
  },
  beforeDestroy() {
    this.$store.dispatch(SET_FORM_CHANGES, []);
  },
  methods: {
    handleFormChange() {
      this.$emit('changedLanguage', { id: this.lang.id, value: true });
    },
    initFormData() {
      this.formData.translateLabel = this.cmsGeneralLanguage.label;
    },
    revertLanguage() {
      const params = {
        accountId: this.getCurrentAccountId,
        cmsPageId: this.cmsPage.id,
        langId: this.lang.id,
      };
      this.$store.dispatch(GET_LANGUAGE_GENERAL_REQUEST, params).then(() => {
        this.$emit('changedLanguage', { id: this.lang.id, value: false });
        this.$store.dispatch(SET_FORM_CHANGES, { id: this.lang.id, value: false });
        this.initFormData();
      });
    },
    getRequestData() {
      const data = {
        label: this.formData.translateLabel,
      };

      return {
        accountId: this.getCurrentAccountId,
        cmsPageId: this.cmsPage.id,
        langId: this.lang.id,
        data,
      };
    },
    onSubmitSuccess() {
      this.$emit('changedLanguage', { id: this.lang.id, value: false });
      this.$store.dispatch(SET_FORM_CHANGES, { id: this.lang.id, value: false });
      this.$toasted.global.success({
        message: this.successMessages,
      });
    },
  },
};
</script>

<style scoped lang="scss">
.translate-wrapper {
}

.poster-title {
  color: #fff;
  font-weight: normal;
  margin-bottom: 10px;
}

.btn-wrapper {
  display: flex;
  flex-wrap: wrap;
  padding-top: 35px;
}

.changes-wrapper {
  display: flex;
  align-items: center;
  border: 1px solid #FB3951;
  border-radius: 2px;
  padding: 8px;
  color: #FB3951;
  margin-left: 20px;
}

.changes-text {
  padding-left: 5px;
}

.btn-wrapper-b {
  display: flex;
}
</style>
